import request from "./request.js";

// 修改密码
export let modifyPwd = data => {
  return request("/user/account/modifyPwd", data);
};

// 修改支付密码
export let setOrModifyPayPwd = data => {
  return request("/user/account/setOrModifyPayPwd", data);
};

// 获取广告内容列表
export let getBySpace = data => {
  return request("/assets/advertising/getBySpace", data);
};

// 获取资讯列表
export let getArticleList = data => {
  return request("/cms/article/getArticleList", data);
};

// 获取个人账户信息
export let getAmount = data => {
  return request("/user/profile/getAmount", data);
};

// 获取FAQ列表
export let getFaqList = data => {
  return request("/cms/faq/getFaqList", data);
};

// 获取FAQ对象
export let getFaq = data => {
  return request("/cms/faq/getFaq", data);
};
// 获取FAQ文章
export let getArticle = data => {
  return request("/cms/article/getArticle", data);
};

// 获取课程列表
export let getCourseList = data => {
  return request("/edu/course/getCourseList", data);
};

// 获取科目列表
export let getSubjectList = data => {
  return request("/edu/course/getSubjectList", data);
};

// 获取课程价格
export let getCoursePrice = data => {
  return request("/edu/course/getCoursePrice", data);
};

// 修改用户头像
export let updateUserPhoto = data => {
  return request("/user/profile/updateUserPhoto", data);
};

// 帐户预存数据获取
export let rechargeSetupList = data => {
  return request("/edu/course/rechargeSetupList", data);
};

// 获取时区列表
export let getTimeZoneList = data => {
  return request("/assets/timeZone/getTimeZoneList", data);
};

// 获取国家列表
export let getCountryList = data => {
  return request("/assets/dist/getCountryList", data);
};

// 添加课件
export let addCourseware = data => {
  return request("/edu/course/courseware/add", data);
};

// 获取课件列表
export let getCoursewareList = data => {
  return request("/edu/course/getCoursewareList", data);
};

// 删除课件
export let delCourseware = data => {
  return request("/edu/course/courseware/delete", data);
};

// 下载课件
export let downloadCourseware = data => {
  return request("/edu/course/courseware/download", data);
};

// 取消预约课程
export let delOrderCourse = data => {
  return request("/edu/course/order/course/cancel", data);
};

// 课程改签
export let changeApply = data => {
  return request("/edu/course/order/changeApply", data);
};

// 获取聊天室id
export let getRoomId = data => {
  return request("/user/yun163/chat/room/get", data);
};

// 获取即将开始课程列表
export let getRecentOrderCourse = data => {
  return request("/edu/course/getRecentOrderCourse", data);
};

// 检测email验证码
export let verifyEmailCode = data => {
  return request("/user/account/verifyEmailCode", data);
};
// 检测手机验证码
export let verifySmsCode = data => {
  return request("/user/account/verifySmsCode", data);
};
export let verifyExist = data => {
  return request("/user/account/verifyExist", data);
};

